import React from 'react';
import { RecallSignIn } from './recall-sign-in';
import { RecallVinInput } from './recall-vin-input';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import AuthenticationService from '../../../services/authentication-service/authentication-service';
import serverSideService from '../../../services/server-side-service/server-side-service';
import { ProfileWithVehiclesResponse } from '../../../models/profile-with-vehicles';
import { FMButton, FMVehicleSelector } from '@own/fds-react';
import { VehicleAttributes } from '../../../models/vehicle-attributes';
import './recall-sign-in-and-vin-input.scss';
import { RecallsUnitedVehicleData } from '../../pages/recalls-united/recalls-united';
import RecallsYmmModal from '../recalls-ymm-modal/recalls-ymm-modal';
interface SignInAndVinInputProps {
    content: RecallsUnitedContent;
    profile?: ProfileWithVehiclesResponse;
    currentVehicle: VehicleAttributes;
    openDrawer: () => void;
    setCurrentVehicle: (vehicle: RecallsUnitedVehicleData) => void;
    vehicles: VehicleAttributes[];
    handleAuthVehicleChange: (
        label: string,
        index: number,
        value: string | undefined
    ) => void;
    isLoggedIn: boolean;
}

export const RecallSignInAndVinInput = (props: SignInAndVinInputProps) => {
    const {
        content,
        profile,
        currentVehicle,
        openDrawer,
        setCurrentVehicle,
        vehicles,
        handleAuthVehicleChange,
        isLoggedIn,
    } = props;
    const authService = new AuthenticationService();
    const recallsAuthentication = () => {
        authService.login();
    };
    let localStorageUserName;
    if (serverSideService.isClientSide()) {
        localStorageUserName = localStorage.getItem('ownLastLoggedInUserFname');
    }
    const authVehicleSelectorContent = {
        addVehicleCtaLabel:
            content.addVehicleCtaLabel && content.addVehicleCtaLink
                ? content.addVehicleCtaLabel
                : '',
        changeVehicleButtonLabel: content.changeVehicleButtonLabel,
        vinLabel: content.vinLabel,
        switchVehicle: content.switchVehicle,
    };

    return (
        <>
            {isLoggedIn && profile?.profile?.firstName ? (
                <div className="recalls-signed-in-selector">
                    {vehicles?.length > 0 ? (
                        <>
                            <div className="recalls-description">
                                {content.authRecallsDescription.replace(
                                    '##CustomerName##',
                                    profile?.profile?.firstName
                                )}
                            </div>

                            <div className="search-by-vin-button-description">
                                {content.searchByVinDescription}
                            </div>
                            <div className="recalls-vin-ymm-search-buttons">
                                <FMButton
                                    label={content.searchByVinLabel}
                                    type="secondary"
                                    onClick={openDrawer}
                                    aria-label={content.openDrawerAriaLabel}
                                    className="recalls-search-by-vin"
                                />
                                <RecallsYmmModal
                                    content={props.content}
                                    isTertiaryButton={true}
                                />
                            </div>

                            {vehicles?.length > 1 && (
                                <FMVehicleSelector
                                    value={currentVehicle}
                                    content={authVehicleSelectorContent}
                                    vehiclesData={vehicles}
                                    handleMenuItemClick={
                                        handleAuthVehicleChange
                                    }
                                    className="recalls-auth-vehicle-selector"
                                />
                            )}
                        </>
                    ) : (
                        <div className="no-vehicle-in-garage">
                            <div className="recalls-description">
                                {content.userHasNoVehicleMessage.replace(
                                    '##CustomerName##',
                                    profile?.profile?.firstName
                                )}
                            </div>
                            <div className="no-vehicle-in-garage-vin-selector">
                                <RecallVinInput
                                    content={content}
                                    onSelect={setCurrentVehicle}
                                    noVehicles={true}
                                />
                                <RecallsYmmModal
                                    content={props.content}
                                    className="recalls-auth-without-vehicles-ymm"
                                />
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <>
                    <div className="recalls-vehicle-selector-container">
                        <div
                            className={`recalls-sign-in-vin-input-container${
                                localStorageUserName ? '' : ' reverse-row'
                            }`}
                        >
                            <RecallSignIn
                                recallsAuthentication={recallsAuthentication}
                                recallsSignInProps={props.content}
                                localStorageUserName={localStorageUserName}
                            />
                            <RecallVinInput
                                content={props.content}
                                onSelect={setCurrentVehicle}
                                hasUsername={localStorageUserName}
                            />
                        </div>

                        <RecallsYmmModal content={props.content} />
                    </div>
                </>
            )}
        </>
    );
};
